import React, { useState } from "react";
import { ArrowLeft, ArrowRight, ArrowUpRight } from "lucide-react";
import { PORTFOLIO_PROJECTS } from "../mock/mock";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

function ProjectCard({ project }) {
  const [activeImage, setActiveImage] = useState(0);

  const nextImage = () => {
    setActiveImage((prev) => (prev + 1) % project.images.length);
  };

  const prevImage = () => {
    setActiveImage((prev) => (prev - 1 + project.images.length) % project.images.length);
  };

  return (
    <article className="overflow-hidden rounded-[28px] border border-[#e4dfd6] bg-white shadow-[0_18px_60px_rgba(0,0,0,0.06)]">
      <div className="relative">
        <img
          src={project.images[activeImage]}
          alt={project.title}
          className="h-64 w-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/10 to-transparent" />
        <div className="absolute left-4 top-4 rounded-full border border-white/30 bg-white/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#111111] backdrop-blur">
          {project.category}
        </div>
        <div className="absolute right-4 top-4 flex gap-2">
          <button
            onClick={prevImage}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-white/40 bg-white/80 text-[#111111] backdrop-blur transition hover:bg-white"
            aria-label="Imagineanterioară"
          >
            <ArrowLeft size={16} />
          </button>
          <button
            onClick={nextImage}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-white/40 bg-white/80 text-[#111111] backdrop-blur transition hover:bg-white"
            aria-label="Următoarea imagine"
          >
            <ArrowRight size={16} />
          </button>
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.24em] !text-[#5b5b5b]">{project.client}</p>
            <h2 className="mt-3 font-display text-[1.45rem] font-semibold leading-tight text-[#111111]">{project.title}</h2>
          </div>
          <span className="mono-label !text-[#6f6f6f]">{project.year}</span>
        </div>

        <p className="mt-5 text-[15px] leading-relaxed text-[#4f4f4f] md:text-[16px]">{project.description}</p>

        <div className="mt-6 flex flex-wrap gap-2">
          {project.metrics.map((metric) => (
            <span key={metric} className="rounded-full border border-[#e0ddd2] bg-[#f7f4eb] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#3c3c3c]">
              {metric}
            </span>
          ))}
        </div>

        <div className="mt-6 grid gap-4 border-t border-[#ece7de] pt-6 md:grid-cols-2">
          <div>
            <p className="mono-label !text-[#111111]">Locație</p>
            <p className="mt-2 text-[15px] text-[#454545] md:text-[16px]">{project.location}</p>
          </div>
          <div>
            <p className="mono-label !text-[#111111]">Servicii</p>
            <ul className="mt-2 space-y-1 text-[15px] text-[#454545] md:text-[16px]">
              {project.services.map((service) => (
                <li key={service}>• {service}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-[#ece7de] bg-[#fcfaf7] p-4">
          <p className="mono-label !text-[#111111]">Puncte cheie</p>
          <ul className="mt-3 space-y-2 text-[15px] text-[#454545] md:text-[16px]">
            {project.highlights.map((highlight) => (
              <li key={highlight} className="flex gap-2">
                <span className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full bg-[#01B72C]" />
                <span>{highlight}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </article>
  );
}

export default function PortfolioPage() {
  return (
    <div className="min-h-screen bg-[#f7f7f2] text-[#111111]">
      <Navbar />
      <main className="pt-24">
        <section className="section-pad py-20 md:py-28">
          <div className="max-w-4xl">
            <h1 className="mt-6 font-display text-[clamp(2.4rem,6vw,4.2rem)] leading-[120%] font-black uppercase leading-[0.95] tracking-[-0.02em]">
              Proiectele noastre
            </h1>
            <p className="mt-6 max-w-2xl text-[16px] leading-relaxed text-[#3f3f3f] md:text-[17px]">
              O selecție de proiecte de construcții, reabilitare și management de investiții care ilustrează abordarea Planimex: claritate, calitate și execuție sigură.
            </p>
          </div>

          <div className="mt-16 grid gap-8 xl:grid-cols-2">
            {PORTFOLIO_PROJECTS.map((project) => (
              <ProjectCard key={project.title} project={project} />
            ))}
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
